/**
 * Get's current cache
 * @param {string} funnelId - The funnel id
 * @returns {SessionCacheData | undefined}
 */
export function getFunnelCache(funnelId = 'tdMainFunnel') {
  const cacheRaw = localStorage.getItem('TD_CACHE') || '{}'
  const cache = JSON.parse(cacheRaw)

  return /** @type {SessionCacheData | undefined} */ (
    cache[`TdSession@${funnelId}`]
  )
}
